<div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)">
  <span class="ft-upload"></span>
  <h6>Suelta los archivos aquí</h6>
  <input hidden type="file" #fileInput (change)="uploadFile($event.target.files)" accept=".pdf" multiple>
</div>
<div class="files-list" *ngFor="let file of filesToShow;let i=index">
  <p>{{ file }}</p>
  <button class="delete-file" (click)="deleteAttachment(i)">
    <span class="icon-trash danger text-bold-600"></span>
  </button>
</div>
<div class="fomr-actions pull-right">
  <button class="btn btn-raised btn-grey mr-3" (click)="onClose()">Cerrar</button>
  <button class="btn btn-raised btn-primary" (click)="sendFilesForUpload()">Listo</button>
</div>